import React, {useEffect, useState} from "react";
import { Link, useHistory } from 'react-router-dom';

import Section from "components/Section";
import { FeatureItem } from "components/Features";
import ImageGalleryC from "components/ImageGalleryC";
import Button from "components/Button";
import Contact from "components/Contact";
import Faq from "components/Faq";
import { Helmet } from "react-helmet";

import {_Skeleton} from "components/Skeletons/SkeletonC";

import settings from "configs/settings";

import req from "functions/req";
import clg from "functions/log";
import { formatRoom } from "functions/formatDynamicData";

import 'assets/css/ApartmentSingle.min.css';
import { formatStatus, formatRoomType, formatOrientation } from "functions/formatDynamicData";
import routes from "configs/routes";
import makeid from "functions/makeid";

const ApartmentSingle = ({ id, ...props }) => {

    const [apartment, setApartment] = useState({});
    const [images, setImages] = useState([]);
    const [status, setStatus] = useState(null);
    const [showSkeletons, setShowSeketons] = useState(true);
    const history = useHistory();

    useEffect(() => {
        get();

        return () => {
            setApartment([]);
            setImages([]);
            setStatus(null);
        }
    },[])

    useEffect(() => {
        if( apartment.hasOwnProperty( "images" ) ) {
            if( Array.isArray( apartment.images ) && apartment.images.length ) {
                rebuildImageArr();
            }
        }
    },[apartment])

    function get() {
        req({
            "method" : "GET",
            "url" : settings.req.propertySingle + "?code=" + id,
        })
        .then(function(res) {
            if( res && res.success ) {
                clg("Apartment Single resp: ", res)
                setApartment( res.data );
                setStatus( formatStatus( res.data.status, "class" ) );

                setShowSeketons(false);

                if( typeof props.callback === "function" ) props.callback( res.data );
            }
        }).catch(err => {
            //Ha nem jön adat, vagy nem érvényes, akkor visszairányítás a /lakasok oldalra
            history.replace(routes.apartments);
        })
    }

    //Helyiségekhez tartozó FeatureItem-ek generálása
    const renderPropertyData = () => {
        let roomData = [];
        let balconyOrTerrace = [];

        {/* Státusz */}
        roomData.push(
            <FeatureItem
                featureItemClass={"col-12 col-sm-6 room-data-feature-item " + formatStatus( apartment.status, "class" )}
                boxFeatureClass="no-shadow light-border"
                hasRealDataWithIcon={true}
                title="Státusz"
                data={ { value: formatStatus( apartment.status, "name" ),} }
                iconClass={"large c-icon-magnifying-glass"}
                key={"room-data-feature-item-status"}
            />
        )

        {/* Tájolás */}
        roomData.push(
            <FeatureItem
                featureItemClass={"col-12 col-sm-6 room-data-feature-item"}
                boxFeatureClass="no-shadow light-border"
                hasRealDataWithIcon={true}
                title="Tájolás"
                data={ { value: formatOrientation( apartment.orientation ).label,} }
                iconClass={"large c-icon-compass"}
                key={"room-data-feature-item-orientation"}
            />
        )

        apartment.all_rooms.map((curr, key) => {
            //Terasz VAGY erkély VAGY loggia adatainak különválasztása, hogy a végén lehessen megjeleníteni
            if( curr.type !== "10" && curr.type !== "11" && curr.type !== "12" && curr.type !== "13" ) {
                roomData.push(
                    <FeatureItem
                        featureItemClass="col-12 col-sm-6 room-data-feature-item"
                        boxFeatureClass="no-shadow light-border"
                        hasRealDataWithIcon={true}
                        title={ formatRoom( curr.type ).name }
                        data={ { value: curr.floor_area, postfix: "m2" } }
                        iconClass={"large " + formatRoom( curr.type ).icon }
                        key={"room-data-feature-item-" + key}
                    />
                )
            } else balconyOrTerrace.push(curr);
        });

        //Erkély vagy terasz megjelenítése
        clg(balconyOrTerrace);
        if( balconyOrTerrace.length > 0 ) {
            roomData.push(
                <div className="col-12 room-data-feature-item excluded-items" key={`room-data-feature-item excluded-items-${makeid()}`}>
                    <div className="row">
                    {
                        (() => {
                            let excludedItems = [];
                            balconyOrTerrace.map((curr,key) => {
                                excludedItems.push(
                                    <FeatureItem
                                        featureItemClass="col-12 col-sm-6 room-data-feature-item"
                                        boxFeatureClass="no-shadow light-border gray-bg"
                                        hasRealDataWithIcon={true}
                                        title={ formatRoom( curr.type ).name }
                                        data={ { value: curr.floor_area, postfix: "m2" } }
                                        iconClass={"large " + formatRoom( curr.type ).icon }
                                        key={"room-data-feature-item-balconyOrTerrace" + key}
                                    />
                                )
                            })
                            return excludedItems;
                        })()
                    }
                    </div>
                </div>
            )}

        roomData.push(
            <FeatureItem
                featureItemClass="col-12 room-data-feature-item pl-3"
                boxFeatureClass="no-shadow light-border"
                hasRealDataWithIcon={true}
                title="Nettó alapterület"
                data={ { value: apartment.floor_area, postfix: "m2" } }
                iconClass={"large c-icon-floor-area"}
                key={"room-data-feature-item-floor_area"}
            />
        )

        roomData.push(
            <FeatureItem
                featureItemClass="col-12 room-data-feature-item mb-5 pl-3"
                boxFeatureClass="no-shadow light-border secondary-gradient-bg floor-area-summary"
                hasRealDataWithIcon={true}
                title="Bruttó alapterület"
                data={ { value: apartment.total_area, postfix: "m2" } }
                iconClass={"large c-icon-summary-white"}
                key={"room-data-feature-item-total_area"}
            />
        )

        return roomData;
    }

    function rebuildImageArr() {
        if( Array.isArray( apartment.images ) ) {
            [...apartment.images].map( curr => {
                const formatted = {
                    original : curr,
                    thumbnail : curr,
                    description : `Lakás - ${apartment.code}`,
                }
                setImages(prevImages => [...prevImages,formatted] );
            })
        }
    }


    console.log(apartment);

    return (
        <>

        {Object.keys(apartment || {}).length > 0 && (
            <Helmet>
                <meta name="description" description={`${apartment.rooms} szobás lakás ${apartment.floor_area} négyzetméter alapterülettel Budapesten a 13. kerületben.`}/>
            </Helmet>
        )}
        
        <Section>
            <div className="container apartment-single-container">
                <div className="row">

                    <div className="col-lg-7 apartment-single-1">

                        {/* <div className="col-12 col-title bg-secondary">
                            <h3>Leírás</h3>
                        </div>

                        <div className="mb-3">{ ( !showSkeletons ? formatRoomType(apartment.rooms, "description") : <_Skeleton count={3} height={20} />) }</div> */}

                        {
                            !showSkeletons ?
                            ( apartment.images && (images.length === apartment.images.length ) ) && (
                                <ImageGalleryC items={ images } />
                            ) 
                            :
                            <_Skeleton count={1} height={500} width={"100%"} />
                            
                        }
                         
                    </div>

                    <div className="col-lg-5 apartment-single-2">
                        <div className="row">

                            <div className="col-12 col-title bg-secondary">
                                <h3>Részletek</h3>
                            </div>

                            {
                                !showSkeletons ?
                                ( apartment.all_rooms && typeof apartment.all_rooms === "object" ) && (
                                    renderPropertyData()
                                )
                                :
                                 <_Skeleton count={1} height={108} width={"100%"} parentClass="room-data-feature-item col-12 col-sm-6" sameCount={ 10 }/>

                                
                            }


                            { !showSkeletons && (
                            <div className="col-12 d-flex">
                                <div className="row btn-container">
                                    {
                                        ( status && status !== "sold" ) && (
                                            <div className="col-12">
                                                <Contact selectedApartment={{ value: apartment.code, label: "Lakás - " + apartment.code }} viewType="modal"/>
                                                {/*<Button text="Ajánlatot kérek" className="btn-secondary large full-width mb-3" icon="far fa-comment-dots" />*/}
                                            </div>
                                        )
                                    }
                                    
                                    <div className="col-12">
                                        {
                                            apartment.pdf && apartment.pdf[0] && (
                                                <a href={apartment.pdf[0]} target="_blank" className="btn btn-primary large full-width" rel="noopener noreferrer"><i className="far fa-file-pdf"></i>PDF letöltése</a>
/*                                                 <Link to={{pathname : apartment.pdf[0]}} target="_blank" className="btn btn-primary large full-width" rel="noopener noreferrer" download={`csango10.hu - lakás - ${apartment.code}.pdf`}><i className="far fa-file-pdf"></i>PDF letöltése</Link>
 */                                            )
                                        }
                                        

                                        {/* <Button text="PDF letöltése" className="btn-primary large full-width" icon="far fa-file-pdf"/> */}
                                    </div>

                                    <div className="col-12 mt-4 asterisk-text">
                                        * A hirdetés nem minősül hivatalos ajánlattételnek. Áraink megváltoztatásának előzetes értesítés vagy közzététel nélküli jogát fenntartjuk. A honlap rendszeres frissítése ellenére előfordulhat, hogy a közölt áradatok nem aktuálisak, vagy a kiválasztott lakás már elkelt. Kérjük, vedd fel ügyintézőnkkel a kapcsolatot, hogy megismerd aktuális árajánlatunkat és a szabad lakásokat.
                                    </div>

                                </div>
                            </div>
                            ) }

                        </div>
                    </div>

                </div>
            </div>
        </Section>

        <Faq sectionAdditionalClasses="pt-0"
            data={[
                /*{
                    title : "Mi a különbség a bruttó és a nettó alapterület között?",
                    description : <div>
                        <span className="mb-1">A bruttó terület a falakkal együtt mért területet jelzi</span>
                        <span className="mb-1">A nettó terület a falak nélkül mért területet jelzi</span>
                    </div>
                },*/
                {
                    title : "A burkolatokat én választom ki?",
                    description : <div>
                        <span className="mb-1">Igen.</span>
                        <ul>
                            <li>Duravit D-CODE szaniterek</li>
                            <li>GROHE csaptelepek</li>
                            <li>Olasz I. osztályú hidegburkolatok/kerámiák</li>
                            <li>Jaffholz ajtók 6 féle színben</li>
                        </ul>
                        <span className="mt-1">Részletekért keresd értékesítőinket.</span>
                    </div>,
                },
                {
                    title : "Hozhatok saját burkolatokat is?",
                    description : "Nem, kivitelezőink a meghatározott termékekkel dolgoznak."
                },
                {
                    title : "A konyhabútor benne van a vételárban?",
                    description : "Nem, a vételár nem foglalja magába a konyhabútort."
                }
            ]}
        />

        </>
    )
}

export default ApartmentSingle;